var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-down"},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("504")]),_c('h1',[_vm._v("Server is down")]),_c('h2',[_vm._v("Connection attempts: "+_vm._s(_vm.conntectionAttempts))]),_c('i',{staticClass:"fa fa-cog fa-spin fa-5x"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a64d224a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ServerDown.vue
// module id = null
// module chunks = 